import { Component, HostListener, Inject, OnDestroy, OnInit, inject, signal, computed } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HelpDialogData } from './help-dialog-data';

@Component({
    selector: 'app-help-dialog',
    templateUrl: './help-dialog.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule
    ]
})
export class HelpDialogComponent implements OnInit, OnDestroy {
    // Services using inject()
    private matDialogRef = inject(MatDialogRef<HelpDialogComponent>);

    // Signals for reactive state
    dialogStyle = signal<string>('');

    // Computed signals
    currentDialogStyle = computed(() => this.dialogStyle());

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public helpDialogData: HelpDialogData
    ) {
    }

    ngOnInit() {
    }

    close(value: any) {
        this.matDialogRef.close(value);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.close('ESC keydown');
    }

    ngOnDestroy() {
    }
}
